import React from "react";
import Index from "../../container/Index";
import { toast } from "react-toastify";
import { sendWhatsappDocumentApiHandler } from "../../services/AdminIndex";

// Every WhatsApp option on the company side shows only when the Super
// Admin has turned WhatsApp Integration on for the company (Company
// Setup). Not loaded yet counts as off.
export const isWhatsappEnabled = (companySetup) => !!companySetup?.utility?.whatsappIntegration;

// List-row WhatsApp icon: sends the document's print PDF to its party.
export default function WhatsappSendButton({ docType, id }) {
  const dispatch = Index.useDispatch();
  const { token, companySetup } = Index.useSelector((state) => state.ERPAdminReducer);

  if (!isWhatsappEnabled(companySetup)) return null;

  const handleSend = () => {
    dispatch({ type: "LOADER_START" });
    sendWhatsappDocumentApiHandler(token, docType, id).then((response) => {
      if (response.status === 201 || response.status === 200) {
        toast.success(response.message);
        dispatch({ type: "LOADER_END" });
      } else {
        dispatch({ type: "ADMIN_ERROR_HANDLER", payload: response });
      }
    });
  };

  return (
    <Index.Tooltip title="Whatsapp" placement="bottom" arrow>
      <Index.Link className="table-btns table-edit-btn" disableRipple onClick={handleSend}>
        <img src={Index.Png.WhatsApp} className="table-icons" alt="" />
      </Index.Link>
    </Index.Tooltip>
  );
}
